import {Injectable, OnDestroy} from "@angular/core";
import {ThemeEnum, ThemeEnumDisplayLabel, ThemeEnumLabel, ThemeLabeltoEnum} from "../enums/ThemeEnum";
import {BehaviorSubject, Subscription} from "rxjs";
import {Auth2Service} from "./security/auth2.service";
import {UtilsService} from "../utils/utils.service";
import {Utilisateur} from "../utilisateur";
import UserDN from "../../../../../pms/src/core/domain/referentiel/UserDN";

@Injectable({
  providedIn: 'root',
})
export class ThemeService implements OnDestroy {
  private defaultTheme: ThemeEnum = ThemeEnum.LEGACY;

  private onThemeChangeSubject = new BehaviorSubject<ThemeEnum>(this.defaultTheme); // Valeur par défaut
  onThemeChange$ = this.onThemeChangeSubject.asObservable();

  subOnUserConnection: Subscription;

  public themesList = []

  constructor(private utilsSvc: UtilsService,
              private auth2Svc: Auth2Service) {
    this.themesList = Object.entries(ThemeEnumDisplayLabel).map(([key, libelle]) => ({
      key: Number(key),
      libelle: libelle
    }));

    this.resetTheme(auth2Svc.utilisateur);
    this.subOnUserConnection = auth2Svc.user$.subscribe(user => {
      this.resetTheme(user);
    })
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOnUserConnection);
  }

  private resetTheme = (user: Utilisateur) => {
    this.onThemeChangeSubject.next(this.getSavedThemeLabel(user));
  }

  setTheme(theme: ThemeEnum) {
    localStorage.setItem(this.getLocalStorageThemeVariableName(this.auth2Svc.utilisateur), this.getThemeLabel(theme));
    this.resetTheme(this.auth2Svc.utilisateur);
  }

  private getSavedThemeLabel(user: Utilisateur): ThemeEnum {
    return ThemeLabeltoEnum[localStorage.getItem(this.getLocalStorageThemeVariableName(user))] || this.defaultTheme; // Valeur par défaut si rien n'est sauvegardé
  }

  public getThemeLabel = (theme: ThemeEnum) => {
    return ThemeEnumLabel[theme];
  }

  private getLocalStorageThemeVariableName = (user: Utilisateur) => {
    return `${user.username}/theme`;
  }

  getThemeList() {
    return this.themesList;
  }

  getCurrentTheme = () => {
    return this.onThemeChangeSubject.value;
  }
}
